import React from 'react';

import RegisterHealthFacilityNotification from './RegisterHealthFacilityNotification';

function NotificationsList(props){
    let notificationsList = [];
    notificationsList = props.list.map(item => 
            <RegisterHealthFacilityNotification {...item}/>);
    return notificationsList;
}

export default NotificationsList;